 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML9780292705111_COVER from '@/components/html/9780292705111_cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML9780292705111_HALFTITLE from '@/components/html/9780292705111_halftitle'
 import HTML9780292705111_ILLUSTRATIONS from '@/components/html/9780292705111_illustrations'
 import HTML9780292705111_TITLE from '@/components/html/9780292705111_title'
 import HTML9780292705111_COPYRIGHT from '@/components/html/9780292705111_copyright'
 import HTML9780292705111_DEDICATION from '@/components/html/9780292705111_dedication'
 import HTML9780292705111_CONTENTS from '@/components/html/9780292705111_contents'
 import HTML9780292705111_LISTOFFIGURES from '@/components/html/9780292705111_listoffigures'
 import HTML9780292705111_LISTOFTABLES from '@/components/html/9780292705111_listoftables'
 import HTML9780292705111_ACKNOWLEDGMENTS from '@/components/html/9780292705111_acknowledgments'
 import HTML9780292705111_HALFTITLE1 from '@/components/html/9780292705111_halftitle1'
 import HTML9780292705111_CH1 from '@/components/html/9780292705111_ch1'
 import HTML9780292705111_CH2 from '@/components/html/9780292705111_ch2'
 import HTML9780292705111_CH3 from '@/components/html/9780292705111_ch3'
 import HTML9780292705111_CH4 from '@/components/html/9780292705111_ch4'
 import HTML9780292705111_CH5 from '@/components/html/9780292705111_ch5'
 import HTML9780292705111_CH6 from '@/components/html/9780292705111_ch6'
 import HTML9780292705111_CH7 from '@/components/html/9780292705111_ch7'
 import HTML9780292705111_CH8 from '@/components/html/9780292705111_ch8'
 import HTML9780292705111_CH9 from '@/components/html/9780292705111_ch9'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML9780292705111_NOTES from '@/components/html/9780292705111_notes'
 import HTML9780292705111_REFERENCES from '@/components/html/9780292705111_references'
 import HTML9780292705111_FIGURESOURCES from '@/components/html/9780292705111_figuresources'
 import HTML9780292705111_INDEX from '@/components/html/9780292705111_index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/9780292705111_contents",
 			"name" : "html/9780292705111_contents",
 			"component" : HTML9780292705111_CONTENTS
 		},
 		{
 			"path" : "/html/9780292705111_listoffigures",
 			"name" : "html/9780292705111_listoffigures",
 			"component" : HTML9780292705111_LISTOFFIGURES
 		},
 		{
 			"path" : "/html/9780292705111_listoftables",
 			"name" : "html/9780292705111_listoftables",
 			"component" : HTML9780292705111_LISTOFTABLES
 		},
 		{
 			"path" : "/html/9780292705111_acknowledgments",
 			"name" : "html/9780292705111_acknowledgments",
 			"component" : HTML9780292705111_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/html/9780292705111_halftitle1",
 			"name" : "html/9780292705111_halftitle1",
 			"component" : HTML9780292705111_HALFTITLE1
 		},
 		{
 			"path" : "/html/9780292705111_ch1",
 			"name" : "html/9780292705111_ch1",
 			"component" : HTML9780292705111_CH1
 		},
 		{
 			"path" : "/html/9780292705111_ch2",
 			"name" : "html/9780292705111_ch2",
 			"component" : HTML9780292705111_CH2
 		},
 		{
 			"path" : "/html/9780292705111_ch3",
 			"name" : "html/9780292705111_ch3",
 			"component" : HTML9780292705111_CH3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js